export default "__VITE_ASSET__2GhOv8Cp__"